/* eslint-disable no-console */
import { register } from 'register-service-worker';

const swVersion = '98';
const logPrefix = '[SW]';
let hasReloaded = false;

function getStoredVersion() {
  return localStorage.getItem('swVersion');
}

function setStoredVersion(version) {
  localStorage.setItem('swVersion', version);
}

function shouldForceReload() {
  return getStoredVersion() !== swVersion;
}

async function unregisterServiceWorkers() {
  const registrations = await navigator.serviceWorker.getRegistrations();
  for (const registration of registrations) {
    console.log(`${logPrefix} Unregistering existing SW...`);
    await registration.unregister();
  }
}

async function clearCaches() {
  if ('caches' in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map(key => caches.delete(key)));
    console.log(`${logPrefix} Cache cleared.`);
  }
}

async function forceReload() {
  await unregisterServiceWorkers();
  await clearCaches();
  setStoredVersion(swVersion);
  if (!hasReloaded) {
    hasReloaded = true;
    console.log(`${logPrefix} Reloading to apply latest SW...`);
    window.location.reload(true);
  }
}

function callRegister() {
  const swUrl = `${process.env.BASE_URL || '/'}service-worker.js?v=${swVersion}`;

  register(swUrl, {
    ready() {
      console.log(`${logPrefix} App is being served from cache.`);
    },
    registered() {
      console.log(`${logPrefix} Service worker registered.`);
      if (shouldForceReload()) {
        forceReload();
      }
    },
    cached() {
      console.log(`${logPrefix} Content cached for offline use.`);
    },
    updatefound() {
      console.log(`${logPrefix} New content is downloading...`);
    },
    updated(registration) {
      console.log(`${logPrefix} New content available. Activating...`);
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        registration.waiting.addEventListener('statechange', e => {
          if (e.target.state === 'activated') {
            setStoredVersion(swVersion);
            if (!hasReloaded) {
              hasReloaded = true;
              console.log(`${logPrefix} New SW activated. Reloading...`);
              window.location.reload(true);
            }
          }
        });
      }
    },
    offline() {
      console.log(`${logPrefix} No internet connection. Offline mode.`);
    },
    error(error) {
      console.error(`${logPrefix} Registration failed:`, error);
    },
  });
}

function processSW() {
  if (process.env.NODE_ENV === 'production') {
    console.log(`${logPrefix} Stored: ${getStoredVersion()} | Current: ${swVersion}`);
    callRegister();
  } else {
    console.log(`${logPrefix} Skipping service worker in development mode.`);
  }
}

processSW();
